export const dateFormats = {
    dateTime: {
        f12: 'dd MMMM yyyy, hh:mm aa',
        f24: 'dd MMMM yyyy, HH:mm',
    },
    time: {
        f12: 'hh:mm aa',
        f24: 'HH:mm',
    },
    dayMonthYear: {
        f12: 'dd MMMM yyyy',
        f24: 'dd MMMM yyyy',
    },
    shortDayMonthYear: {
        f12: 'dd MMM yyyy',
        f24: 'dd MMM yyyy',
    },
} as const

export type DateFormats = keyof typeof dateFormats
